/* eslint-disable no-irregular-whitespace */
/* eslint-disable no-unused-vars */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import 'animate.css'
// eslint-disable-next-line no-irregular-whitespace
import ElementUI from 'element-ui'
import App from './App'
import router from './router'
import navBar from '@/layout/components/navBar'
import goTop from '@/layout/components/goTop'
import pendant from '@/layout/components/pendant'

import VueAwesomeSwiper from 'vue-awesome-swiper'
// import videojs from "video.js";
// eslint-disable-next-line no-irregular-whitespace
import 'element-ui/lib/theme-chalk/index.css'

import 'swiper/swiper-bundle.css'

import * as tools from './utils/tools.js'

import request from '@/request/request'

import '@/style/animate.min.css'
import '@/style/index.scss' // global css
// eslint-disable-next-line no-irregular-whitespace
import '@/style/iconfont.scss'
ElementUI.Dialog.props.lockScroll.default = false

Vue.component('navBar', navBar)
Vue.component('goTop', goTop)
Vue.component('pendant', pendant)

Vue.use(VueAwesomeSwiper)
Vue.use(ElementUI)
Vue.prototype.post = request.post
Vue.prototype.get = request.get
Vue.prototype.$tools = tools
Vue.prototype.$apiUrl = 'https://data.zhongshengrunde.com/'
Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  if (to.name.includes('Details') || to.name.includes('Video')) {
    let token = localStorage.getItem('token')
    if (!token) {
      router.push({path: '/login'})
      // sessionStorage.setItem('navId',6)
      // Vue.reload()
    }
  }

  next()
})
// eslint-disable-next-line no-irregular-whitespace
// 跳转页面返回顶部
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})

// 时间戳转时间格式
Vue.prototype.gettime = function (fmt) {
  var time = ''
  var date = new Date(fmt * 1000)
  var Y = date.getFullYear()
  var M = date.getMonth() + 1
  var D = date.getDate()
  var h = date.getHours()
  var m = date.getMinutes()
  if (m < 10) {
    m = '0' + m
  }
  var s = date.getSeconds()
  if (s < 10) {
    s = '0' + s
  }
  time = Y + '年' + M + '月' + D + '日' + '' + h + ':' + m + ':' + s
  // eslint-disable-next-line no-unused-expressions
  return time
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js